// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__NmJqY","unreadBadge":"styles_unreadBadge__239ZG","modalContent":"styles_modalContent__3QgUh","modal":"styles_modal__dgVpC"};